import { apiGet, apiPost } from './api';

export interface GardenerInvite {
	id: number;
	code: string;
	company_id: number;
	company_name?: string;
	invited_email?: string | null;
	invited_phone?: string | null;
	status: 'pending' | 'used' | 'expired' | 'cancelled';
	expires_at?: string | null;
	used_at?: string | null;
	used_by_user_id?: number | null;
	created_by_user_id?: number | null;
	company_member_id?: number | null;
}

export interface GardenerInviteDetailsResponse {
	invite: {
		id: number;
		code: string;
		status: GardenerInvite['status'];
		expires_at: string | null;
		company_id: number;
	};
	company: {
		id: number;
		name: string;
	};
}

export async function createGardenerInvite(payload: {
	userId: number;
	companyId?: number;
	invitedEmail?: string;
	invitedPhone?: string;
	expiresAt?: string;
}): Promise<GardenerInvite> {
	const body: any = {
		userId: payload.userId,
		invitedEmail: payload.invitedEmail,
		invitedPhone: payload.invitedPhone,
		expiresAt: payload.expiresAt
	};
	if (payload.companyId != null) body.companyId = payload.companyId;
	return apiPost<GardenerInvite>('/gardener-invites', body);
}

export async function getGardenerInviteByCode(code: string): Promise<GardenerInviteDetailsResponse> {
	return apiGet<GardenerInviteDetailsResponse>(`/gardener-invites?code=${encodeURIComponent(code)}`);
}

export async function acceptGardenerInvite(userId: number, code: string): Promise<{ message: string; company: { id: number; name: string }; company_member_id: number | null }> {
	const params = new URLSearchParams({ userId: String(userId) });
	return apiPost<{ message: string; company: { id: number; name: string }; company_member_id: number | null }>(
		`/gardener-invites/accept?${params.toString()}`,
		{ code }
	);
}

